import axios from 'axios';
import API_CONFIG from '../config/api';
import { translateVi } from '../i18n/LocaleContext';

const API_URL = API_CONFIG.getApiUrl(API_CONFIG.ENDPOINTS.WITHDRAW);

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

export const withdrawService = {
  // Tạo yêu cầu rút tiền
  createWithdraw: async (withdrawData) => {
    try {
      const response = await axios.post(API_URL, withdrawData, getAuthHeader());
      return response.data;
    } catch (error) {
      if (error.response?.data) {
        throw error; // Preserve full error response including errorCode
      }
      throw new Error(translateVi('Không thể tạo yêu cầu rút tiền'));
    }
  },

  // Lấy lịch sử rút tiền
  getHistory: async (limit = 50) => {
    try {
      const response = await axios.get(`${API_URL}/history?limit=${limit}`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy lịch sử rút tiền'));
    }
  }
};
